import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PrintService } from "../services/print.service";
import { ErrorService } from "../services/errors.service";
import { SocialHousingService } from "../services/social-housing.service";

@Component({
  selector: "app-print-report",
  templateUrl: "./print-report.component.html",
  styleUrls: ["./print-report.component.scss"],
})
export class PrintReportComponent implements OnInit {
  resultData: string[];

  constructor(
    private route: ActivatedRoute,
    private printService: PrintService,
    private socialService: SocialHousingService,
    private errorService: ErrorService,
  ) {}

  ngOnInit() {
    if (this.socialService.lastSearchResult) {
      this.printService.onDataReady();
    }
  }
}
